<template>
<div>
  <el-form-item label="留资 Source">
    <el-input
        placeholder="请输入留资 Source"
        v-model.trim="temp.source">
    </el-input>
    <el-form-item label="背景颜色">
      <el-color-picker
        size="mini"
        v-model="temp.background">
      </el-color-picker>
    </el-form-item>
  </el-form-item>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="字段配置：" name="1">
      <div class="attr-item-edit-wrapper marginB15">
        <div class="sizeAndPosition-wrapper">
          <el-form-item label="公司名称">
            <el-switch v-model="temp.company"></el-switch>
          </el-form-item>
          <el-form-item label="姓名">
            <el-switch v-model="temp.name"></el-switch>
          </el-form-item>
          <el-form-item label="手机号">
            <el-switch v-model="temp.phone"></el-switch>
          </el-form-item>
          <el-form-item label="行业报告">
            <el-switch v-model="temp.source_desc"></el-switch>
          </el-form-item>
          <el-form-item label="行业报告">
            <el-input
                type="textarea"
                :rows="5"
                placeholder="请输入行业选项"
                v-model="tempSourceOptions"
                @change="changeOptions">
            </el-input>
          </el-form-item>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</div>

</template>

<script>
	export default {
		name: "attr-sourceFormConfig",
		props: {
      sourceFormConfig: {
        type: Object
      }
		},
		data() {
			return {
        activeNames: ['1'],
        temp: {
          source: ''
        },
        tempSourceOptions: ''
			}
		},
		mounted() {
			this.temp = this.sourceFormConfig;
      this.tempSourceOptions = this.sourceOptions
		},
    computed: {
      sourceOptions () {
        return this.sourceFormConfig.sourceOptions.join('\n')
      }
    },
		watch: {
			noticeBarStyle(val) {
				this.temp = val;
			},
			temp:{
        handler(){
          this.$emit('update:sourceFormConfig', this.temp);
        },
        deep:true
			}
		},
    methods: {
      changeOptions (val) {
        this.temp.sourceOptions = val.split('\n')
      }
    }
	}
</script>

<style scoped>

</style>
